import { useQuery } from '@tanstack/react-query';
import { asyncErrorHandler } from '../../utils/async-error-handler';
import axios from 'axios';
import { tagServiceDataSchema } from './tag.schema';
import { attachApiErrorToastInterceptor } from '../../utils/api-error-toast';

export const axiosTokenInst = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_TAG_GET_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
attachApiErrorToastInterceptor(axiosTokenInst);

export const useTagService = () => {
  return useQuery({
    queryKey: ['get-tags'],
    queryFn: asyncErrorHandler(async () => {
      if (process.env.REACT_APP_API_BASE_TAG_GET_URL) {
        const response = await axios.get(process.env.REACT_APP_API_BASE_TAG_GET_URL);
        const data = tagServiceDataSchema.parse(response.data.data);
        return data;
      }
    }),
  });
};
